/* ════════════════════════════════════════════════════════════════════════════
 *  ⚙️  ENGINE SELECTION
 * ════════════════════════════════════════════════════════════════════════════
 *
 *  Default: the REAL local Maestro engine.
 *  Switch back to the simulated engine (no real generation) via .env:
 *
 *      VITE_ENGINE=mock
 *
 *  Related settings (all optional, all in .env):
 *      VITE_MAESTRO_BASE_URL=http://127.0.0.1:7860   # skip port auto-discovery
 *      VITE_MAESTRO_MODEL=ti2v_2_2_fastwan           # which model to use
 *      VITE_MAESTRO_VIDEO_LENGTH=121                 # clip length in frames
 * ════════════════════════════════════════════════════════════════════════════ */

import { mockProvider } from './mockProvider';
import { maestroProvider } from './maestroProvider';
import type { GenerationProvider, GenerationSettings } from './types';

const requested = String(import.meta.env?.VITE_ENGINE ?? '').trim().toLowerCase();

/** True when the app was explicitly put back into simulated mode. */
export const isMockEngine = requested === 'mock';

export const provider: GenerationProvider = isMockEngine ? mockProvider : maestroProvider;

/**
 * Pre-run time estimate for the active engine. Providers that cannot give one
 * fall back to a neutral guess so the UI always has something to show.
 */
export function estimateSeconds(settings: GenerationSettings): number {
  return provider.estimateSeconds?.(settings) ?? 30;
}

export * from './types';
